// import React, { useState } from 'react'
// import { MapPin, Clock, DollarSign, Star, MessageCircle, Heart, Share2, Zap, Crown, Fire, Sparkles, Send, Eye, TrendingUp, Award, Shield, Camera, ChevronRight, Play, Volume2 } from 'lucide-react';
// import './Proposal.css';
// import { useDispatch } from 'react-redux';

// const Proposel = ({ selectedJob, closeRequestModal }) => {
//   const dispatch = useDispatch();
//   const [requestAmount, setRequestAmount] = useState('');
//   const [requestMessage, setRequestMessage] = useState('');
//   const selectedJob = jobPosts.find((j) => j.id === showRequestModal || j._id === showRequestModal);

//   console.log(selectedJob,"selected job")
//   const submitRequest = () => {
//     closeRequestModal();
//   };

//   return (
//     <div className="proposal-overlay">
//       <div className="proposal-gradient-border">
//         <div className="proposal-main-container">
//           <div className="proposal-header">
//             <h3 className="proposal-title">
//               <Sparkles className="proposal-title-icon" />
//               <span>Send Proposal</span>
//             </h3>
//             <p className="proposal-subtitle">Make your best offer and stand out!</p>
//           </div>
          
//           <div className="proposal-form-container">
//             <div className="form-group">
//               <label className="form-label">Your Quote Amount</label>
//               <div className="input-wrapper">
//                 <DollarSign className="input-icon" />
//                 <input
//                   type="number"
//                   value={requestAmount}
//                   onChange={(e) => setRequestAmount(e.target.value)}
//                   placeholder="Enter your competitive quote"
//                   className="amount-input"
//                 />
//               </div>
//               <div className="budget-hint">
//                 Budget: ₹{jobPosts.find(j => j.id === showRequestModal)?.priceRange.min.toLocaleString()} - ₹{jobPosts.find(j => j.id === showRequestModal)?.priceRange.max.toLocaleString()}
//               </div>
//             </div>

//             <div className="form-group">
//               <label className="form-label">Proposal Message</label>
//               <textarea
//                 value={requestMessage}
//                 onChange={(e) => setRequestMessage(e.target.value)}
//                 placeholder="Tell them why you're perfect for this job..."
//                 rows={4}
//                 className="message-textarea"
//               />
//             </div>

//             <div className="button-container">
//               <button
//                 onClick={closeRequestModal}
//                 className="cancel-button"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={submitRequest}
//                 disabled={!requestAmount}
//                 className="submit-button"
//               >
//                 <Send className="button-icon" />
//                 <span>Send Proposal</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Proposel


import { MapPin, Clock, DollarSign, Star, MessageCircle, Heart, Share2, Zap, Crown, Fire, Sparkles, Send, Eye, TrendingUp, Award, Shield, Camera, ChevronRight, Play, Volume2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import "./Proposal.css"
import { myServices, setMyServiceData } from '../../../Redux/Slices/Pages/services/servicesSlice';
import { createProposal } from '../../../Redux/Slices/Pages/Proposal/ProposalSlice';

const Proposel = ({ selectedJob, closeRequestModal }) => {

  const dispatch = useDispatch();
  const myServiceInfo = useSelector((state) => state.services.myServiceData);
  
  console.log(myServiceInfo,"myservices")
  const [requestAmount, setRequestAmount] = useState('');
  const [requestMessage, setRequestMessage] = useState('');
  const [selectedServiceId, setSelectedServiceId] = useState('');

  const [myServiceData,setMyserviceData]=useState([]);

  console.log(selectedJob,"selected jobs")

  const data={
    workId:selectedJob?._id,
    serviceId:selectedServiceId,
    amount:requestAmount,
    message:requestMessage

  }
  console.log(data,"data")

  const submitRequest = () => {
     if (!selectedServiceId || !requestAmount) return;
     dispatch(createProposal(data))
    // You can dispatch here if needed
    closeRequestModal();
  };

    useEffect(() => {
      dispatch(myServices());
      return () => {
        dispatch(setMyServiceData([]));
      };
    }, []);

  return (
    <div className="proposal-overlay">
      <div className="proposal-gradient-border">
        <div className="proposal-main-container">
          <div className="proposal-header">
            <h3 className="proposal-title">
              <span>Send Proposal</span>
            </h3>
            <p className="proposal-subtitle">Make your best offer and stand out!</p>
          </div>

          <div className="proposal-form-container">
            <div className="form-group">
              <label className="form-label">Your Quote Amount</label>
              <div className="input-wrapper">
                <DollarSign className="input-icon" />
                <input
                  type="number"
                  value={requestAmount}
                  onChange={(e) => setRequestAmount(e.target.value)}
                  placeholder="Enter your competitive quote"
                  className="amount-input"
                />
              </div>
              {/* <div className="budget-hint">
                Budget: ₹{selectedJob?.priceRange?.min} - ₹{selectedJob?.priceRange?.max}
              </div> */}
            </div>

            <div className="form-group">
  <label className="form-label">Select Your Profession</label>
  <select  
    className=" amount-input"
    value={selectedServiceId}
    onChange={(e) => setSelectedServiceId(e.target.value)}
  >
    <option value="">-- Select Profession --</option>
    {myServiceInfo?.map((service) => (
      <option key={service._id} value={service._id}>
        {service.profession}
      </option>
    ))}
  </select>
</div>

            <div className="form-group">
              <label className="form-label">Proposal Message</label>
              <textarea
                value={requestMessage}
                onChange={(e) => setRequestMessage(e.target.value)}
                placeholder="Tell them why you're perfect for this job..."
                rows={2}
                className="message-textarea"
              />
            </div>

            <div className="button-container">
              <button onClick={closeRequestModal} className="cancel-button">Cancel</button>
              <button onClick={submitRequest} disabled={!requestAmount} className="submit-button">
                <Send className="button-icon" />
                <span>Send Proposal</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Proposel;
